"use client";

import { useEffect } from "react";

/**
 * Intercepts server action fetch calls and reloads the page when they return 404.
 * This handles the case where the server has been redeployed with new action IDs
 * and the client is still running a stale build.
 */
export function ServerActionReloadHandler() {
  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = async function patchedFetch(...args: Parameters<typeof fetch>) {
      const response = await originalFetch.apply(window, args);

      const init = args[1];
      if (!init?.headers) return response;

      const hasServerAction =
        init.headers instanceof Headers
          ? init.headers.has("Next-Action")
          : Array.isArray(init.headers)
            ? init.headers.some(([key]) => key.toLowerCase() === "next-action")
            : typeof init.headers === "object" && "Next-Action" in init.headers;

      if (hasServerAction && response.status === 404) {
        window.location.reload();
      }

      return response;
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return null;
}
